import { FC, useState } from 'react';
import { Hand } from 'lucide-react';

import { IconProps } from '../../shared/ui';

export const RaiseHandIcon: FC<IconProps> = ({
  width = 48,
  height = 48,
  className,
  checked = false,
  needHover = true,
}) => {
  const [hover, setHover] = useState(false);
  const cursorClass = needHover ? 'hover:cursor-pointer' : 'cursor-default';
  const backgroundFill = checked ? '#2C3038' : hover && needHover ? '#6F6F6F' : '#828282';
  const iconSize = Math.round(Math.min(width, height) * 0.58);

  return (
    <div
      className={`${cursorClass} inline-flex shrink-0 items-center justify-center ${className ?? ''}`.trim()}
      style={{ width, height, borderRadius: 10, backgroundColor: backgroundFill }}
      title="Поднять руку"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <Hand size={iconSize} color="#FFFFFF" strokeWidth={2} aria-hidden />
    </div>
  );
};
